<ngx-spinner bdColor="rgba(0,0,0,0.3)" size="medium" color="#0DB4E8" type="ball-clip-rotate"></ngx-spinner>

<app-approve-reject-modal *ngIf="modalVisible && selectedItem" [action]="modalAction"
    [expenseLabel]="selectedItem.type_label + ' — ' + formatCurrency(selectedItem.amount)"
    (confirmed)="onModalConfirmed($event)" (cancelled)="closeModal()"></app-approve-reject-modal>

<div class="ev-wrapper rounded" [style.paddingBottom.px]="resumenPanelHeight + 40">

    <!-- Breadcrumb -->
    <!-- <nav class="ev-breadcrumb">
        <span class="ev-bc-muted">Control de gastos</span>
        <span class="ev-bc-sep">/</span>
        <span class="ev-bc-muted">Listado de servicios finalizados</span>
        <span class="ev-bc-sep">/</span>
        <span class="ev-bc-active">Validación de gastos</span>
    </nav> -->

    <!-- Page header -->
    <div class="ev-page-header">
        <h4 class="ev-page-header__title">Validación gastos del servicio{{ service?.folio ? ' - Folio ' + service.folio : '' }}</h4>
        <div class="ev-header-actions">
            <ng-container *ngIf="canDo('Descargar')">
                <button class="ev-btn-download ev-btn-download--outline" (click)="downloadXls()">
                    <i class="ti ti-download"></i> Descargar XLS
                </button>
                <button class="ev-btn-download ev-btn-download--solid" (click)="downloadPdf()">
                    <i class="ti ti-download"></i> Descargar PDF
                </button>
            </ng-container>
            <button *ngIf="!isValidated && canDo('Validar')" class="ev-btn-validate" (click)="openValidationModal()">
                <i class="ti ti-circle-check"></i> Validar gastos
            </button>
        </div>
    </div>

    <!-- Main card -->
    <div class="ev-main-card border">

        <!-- ── Datos del servicio ────────────────────────────────── -->
        <div class="ev-service-header" (click)="serviceCollapsed = !serviceCollapsed">
            <span class="ev-service-header__title">Datos del servicio</span>
            <i class="ti" [ngClass]="serviceCollapsed ? 'ti-chevron-down' : 'ti-chevron-up'"></i>
        </div>

        <div class="ev-service-body" [class.ev-hidden]="serviceCollapsed">
            <div class="ev-service-grid">

                <!-- Left -->
                <div class="ev-col">
                    <div class="ev-field">
                        <label class="ev-label">Estado de México</label>
                        <select class="ev-value ev-value--input" [(ngModel)]="estado" (change)="onEstadoChange()" [disabled]="isValidated">
                            <option [ngValue]="null">Selecciona un estado</option>
                            <option *ngFor="let e of estadosMexico" [value]="e">{{ e.toUpperCase() }}</option>
                        </select>
                    </div>
                    <div class="ev-field">
                        <label class="ev-label">Destino</label>
                        <div class="ev-value">{{ service?.destination_address || '—' }}</div>
                    </div>
                    <div class="ev-field">
                        <label class="ev-label">Operador/Auxiliar</label>
                        <div class="ev-value">{{ service?.driver?.name || '—' }}</div>
                    </div>
                    <div class="ev-field">
                        <label class="ev-label">Unidad</label>
                        <div class="ev-value">{{ service?.unit?.unit || '—' }}</div>
                    </div>
                    <div class="ev-field">
                        <label class="ev-label">Cliente</label>
                        <div class="ev-value">{{ service?.client?.name || '—' }}</div>
                    </div>
                    <div class="ev-dt-row">
                        <div class="ev-field">
                            <label class="ev-label">Kilometraje inicial</label>
                            <div class="ev-value">{{ initialKm !== null ? (initialKm | number) : '—' }}</div>
                        </div>
                        <div class="ev-field">
                            <label class="ev-label">Kilometraje final</label>
                            <div class="ev-value">{{ finalKm !== null ? (finalKm | number) : '—' }}</div>
                        </div>
                    </div>
                </div>

                <!-- Right -->
                <div class="ev-col">
                    <div class="ev-section-label">
                        Entrada y salida primera caseta - TAG
                        <i *ngIf="savingTripDates" class="ti ti-loader-2 ev-km-summary__saving"></i>
                    </div>
                    <div class="ev-dt-group">
                        <span class="ev-dt-sublabel">Fecha y hora de entrada</span>
                        <div class="ev-dt-row">
                            <input type="date" class="ev-value ev-value--input" [(ngModel)]="tagBoothEntryDate" (blur)="onTripDateBlur()" [disabled]="isValidated">
                            <input type="time" class="ev-value ev-value--input" [(ngModel)]="tagBoothEntryTime" (blur)="onTripDateBlur()" [disabled]="isValidated">
                        </div>
                    </div>
                    <div class="ev-dt-group">
                        <span class="ev-dt-sublabel">Fecha y hora de salida</span>
                        <div class="ev-dt-row">
                            <input type="date" class="ev-value ev-value--input" [(ngModel)]="tagBoothExitDate" (blur)="onTripDateBlur()" [disabled]="isValidated">
                            <input type="time" class="ev-value ev-value--input" [(ngModel)]="tagBoothExitTime" (blur)="onTripDateBlur()" [disabled]="isValidated">
                        </div>
                    </div>

                    <div class="ev-section-label ev-section-label--mt">Entrada y salida de patios</div>
                    <div class="ev-dt-group">
                        <span class="ev-dt-sublabel">Fecha y hora de entrada</span>
                        <div class="ev-dt-row">
                            <input type="date" class="ev-value ev-value--input" [(ngModel)]="patioEntryDate" (blur)="onTripDateBlur()" [disabled]="isValidated">
                            <input type="time" class="ev-value ev-value--input" [(ngModel)]="patioEntryTime" (blur)="onTripDateBlur()" [disabled]="isValidated">
                        </div>
                    </div>
                    <div class="ev-dt-group">
                        <span class="ev-dt-sublabel">Fecha y hora de salida</span>
                        <div class="ev-dt-row">
                            <input type="date" class="ev-value ev-value--input" [(ngModel)]="patioExitDate" (blur)="onTripDateBlur()" [disabled]="isValidated">
                            <input type="time" class="ev-value ev-value--input" [(ngModel)]="patioExitTime" (blur)="onTripDateBlur()" [disabled]="isValidated">
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- ── Tabs ─────────────────────────────────────────────── -->
        <div class="ev-tabs">
            <div class="ev-tab" [class.ev-tab--active]="activeTab==='combustible'" (click)="activeTab='combustible'">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" fill="url(#pattern0_1_37898)"/>
                    <defs>
                        <pattern id="pattern0_1_37898" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_1_37898" transform="scale(0.0208333)"/>
                        </pattern>
                        <image id="image0_1_37898" width="48" height="48" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADpUlEQVR4Ae3BX2jUdQAA8M9uP+ge7mEPIw466LCgPezBUCjS2MqkKRMvuocRhAoaPvgQaCik5MOE/igZ2kNPvShbbNFiSoM0NirKUCJSmXDFggWXXLLgqj0ckvAdLN3vdnfbPRTe56OlpaWl5b7WpjlS2IhePIYupJARFFHGNAq4hEkUrVKblUuiHzvQh0jjvsJZDGPOCrRpXBJ7cRBpi37CKKYxgyJmBWlkkEEW/XjCojm8h5OY04A2jcnhXWQFP2AUwyhoTAZ92IkNgiJewxl1alOfFE5hp2AWR3AGFauXw3E8IhjFLpTV0Ka2LoygG2Ucw0nMa64Iu/EOUihgG6Yto93yunERazCLzRhFRfPdxmWMYyvWII/zKKmiXXVdmMKDuIRNKIiXRR5rcN3q3MRHeBpdGMA4SmK0i5fGl0jjPLZiTnXf4Fm8gmu4bnXKOIPHsRY5DKHsHglLRRhCBtMYwLzlZdEhyKquH3+jT23zGMA1ZDCCyD0SljqEXsxhG8pqO4EibmBMda8iiYz6lJFDCRsx6B7t7vYohhDhBXynPl/gfZzGLfE6cQq3sQd/qc8tfI+X8BQ+wU0LEu52HEl8ignNlUOEKZQ05gLOIsIp/5KwaC22o4ID4mWxG3mNGxAMWypCHnuRFe8o5tGLXgsSFh0QnEVBvM/wOkaQV79O9KCCMUvlMYKDGBdvBh8IDlmQEKTwomBQdVl0CLLql0OEKZQslRV0IKu6QczjeWTckRDkkcQVFFR3AkXcwJj6DQiGxRvFNRRxQnUlfC3IuyMS9AnOWd5hHNaYTvSggjHxCuhWnwlsQh9OJgQ9gnOaL4cIUyhZvXOCDe5IIIM0fsdlzTcgGNYc0/gNKXQl0CWY0Xyd6EEFY5qnIMhGyAhK4g1iOyJswYz65RDhIkrqk8W44GMctdScIJ1AWlAUbz8y6EJefTqQxz7Bz0ipzwC68RD2i1cSpCMkBbPi/YIH0IEZy0vhDexD0qI9eBmncQTzqpsR/IE/xZsVJCOLKuL1oxdljKquA59jveAKvhU8iXU4gF5sxpx4o4IOXBCvYkGktgIKahvBesxgFybdrRcfYj2GsEW8CobVKaE5cngOZTyDSUtNYjPK6ENOEyQ0x27BMcyoroBjgp2aIIGSIG3l1gkm1DYhWGfl0oJSApOoYAdyiDQuLbiqtquCjMZFyGEHKphsE7yJg/5f3sKhdsEF/IqH0YmE/6YKfsQRvK2lpaWl5b73D1sw4ZGh5DgIAAAAAElFTkSuQmCC"/>
                    </defs>
                </svg>
                <span>Combustible</span>
            </div>
            <div class="ev-tab" [class.ev-tab--active]="activeTab==='casetas'" (click)="activeTab='casetas'">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" fill="url(#pattern0_1_37901)"/>
                    <defs>
                        <pattern id="pattern0_1_37901" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_1_37901" transform="scale(0.0208333)"/>
                        </pattern>
                        <image id="image0_1_37901" width="48" height="48" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADyElEQVR4Ac3BX2hVdQAA4G/3/oIFe9hD0CF66KHiYBaDpJQsdkp0wSChv9SMqEBBIcECI2KGQgYKe+ihiChoYkWh/YEijaPFYuACS4UThUwSOkgPSwyGXazgDLbJ7u7ddu7V79OE9XjCVaqqsWN4EstxCJOuIlWN/Y616MEATuC0q0RVYz9jP1ZhGZ5GF75HzRVW1ZwJvI9/cB9Wox8jOOcKqmreJXyHQ+jFMjyLvzHqCqlauLN4D9fjLvRhJY7ivDarWpyL+Bw/YQ3uwNP4FZk2qlqaDPtxG+7AE7gRKS5qg6qlO49h/IVe3IXHcAxntVhVeUbxGe7BMjyDf/EDLmmRqnKdw/u4FqtxP9biW0xogary1fANRnA/luF5/IHjSlbVOqfxHm5BD9ZjOQ5hUkmqWmsSH+MM1qAHAziB00rQgW5sQbA4NWQ4jAn13YQPcbfCHryKSUvQge143dJN4A3sVl/Adgwi4Dg24KRF6kA3tiBYnE70YJ3CXrxofivxAW7GJF7GkEXoUJ5efIEurMKo+XVhCM8pHMaIxmoYw9f+16FcOzCIb7FGc9bjHVxnYYaxISjXELbhAfTguMYOogeDOIKj5hewGQPYF5RrAu/iBWzFMxbmKHZozitYUVG+IdTwOCLli/CwQqgo3zg+Qye2KleEFLEpFa2xR2EjOpUjQorYDBWtMYoRdGOTpYuQIkaGt00J6McBBK3xEsZx0OJESBEjQ4JNplS03g04gK/QbWEipIiRIUFuhoAvcY3yBaxAH7ahD4dwLyY1FiFFjAwJcpepaJ0aRrEDt+MsVmCXxiKkiJEhQW4OFe0xjg0Km9GlvggpYmRIkKujon2O4Ed0os/cIqSIkSFBbrYIj5sSlG8XHkLAgxg3bRR34iZz26iQIUFutggpYlMqyrcNNyLGI2b7U6FLfRkS5GaLkCI2Q0X5zmBCYdzCZEiQmy1CihgZ3jYlKF8/enEBn1iYj5CbLUKKGBkSbDIlKN9v+E05IqSIkSFBboaK9goKNY1FSBEjQ4LcZSraJ2Cdwknzi5AiRoYEuTkEdGMLgtYJeBS34hccVl+EFDEyJMjVEbAJO7XPI7hgbhFSxMiQIDePgLcQEJRjUOE102rYqXBSfRsVMiTINRAwgV3KM6iww2w7NSdDglwTKspXUwimBYWa+WVIkGtSRflOKfSb1q9wytxqCp8i11hQqAXlexPvYD+GFQYUhsxtTGGzQk19AZsVxjq0xm5sQ1CoYS+2q28YT2nePgx0aJ0YvQpHkGmsDysQ1FfDGL72v/8Aai/rY0bw320AAAAASUVORK5CYII="/>
                    </defs>
                </svg>
                <span>Casetas</span>
            </div>
            <div class="ev-tab" [class.ev-tab--active]="activeTab==='alimentos'" (click)="activeTab='alimentos'">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M10 15.8446L6.68575 19.1589C7.45757 19.7089 7.56154 20.8655 6.88551 21.5416C6.27426 22.1528 5.28323 22.1528 4.67198 21.5416C4.19008 21.0597 4.02512 20.2787 4.30305 19.6969C3.72125 19.9749 2.94033 19.8099 2.45844 19.328C1.84719 18.7168 1.84719 17.7257 2.45844 17.1145C3.13447 16.4385 4.29108 16.5424 4.84114 17.3142L8.15538 14" stroke="#141B34" stroke-width="1.5" stroke-linejoin="round"/>
                    <path d="M12.5368 3.68189C14.8712 1.34751 18.1694 1.53315 20.3181 3.68189C22.033 5.39675 22.4975 7.8437 21.4285 9.94858C19.6533 7.59535 15.6579 9.39829 16.4055 12.3559C14.7572 11.6697 13.3426 13.7886 14.478 15.0632C12.0982 16.0318 9.73049 16.4381 8.64618 15.3538C6.49743 13.2051 10.2024 6.01628 12.5368 3.68189Z" stroke="#141B34" stroke-width="1.5" stroke-linejoin="round"/>
                </svg>
                <span>Alimentos</span>
            </div>
            <div class="ev-tab" [class.ev-tab--active]="activeTab==='otros'" (click)="activeTab='otros'">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M2 12C2 8.46252 2 6.69377 3.0528 5.5129C3.22119 5.32403 3.40678 5.14935 3.60746 4.99087C4.86213 4 6.74142 4 10.5 4H13.5C17.2586 4 19.1379 4 20.3925 4.99087C20.5932 5.14935 20.7788 5.32403 20.9472 5.5129C22 6.69377 22 8.46252 22 12C22 15.5375 22 17.3062 20.9472 18.4871C20.7788 18.676 20.5932 18.8506 20.3925 19.0091C19.1379 20 17.2586 20 13.5 20H10.5C6.74142 20 4.86213 20 3.60746 19.0091C3.40678 18.8506 3.22119 18.676 3.0528 18.4871C2 17.3062 2 15.5375 2 12Z" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M10 16H11.5" stroke="#141B34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14.5 16L18 16" stroke="#141B34" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 9H22" stroke="#141B34" stroke-width="1.5" stroke-linejoin="round"/>
                </svg>
                <span>Otros gastos</span>
            </div>
            <div class="ev-tab" [class.ev-tab--active]="activeTab==='depositos'" (click)="activeTab='depositos'">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect width="24" height="24" fill="url(#pattern0_1_37910)"/>
                    <defs>
                        <pattern id="pattern0_1_37910" patternContentUnits="objectBoundingBox" width="1" height="1">
                            <use xlink:href="#image0_1_37910" transform="scale(0.0208333)"/>
                        </pattern>
                        <image id="image0_1_37910" width="48" height="48" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACgUlEQVR4Ad3BMYhTZwAA4C+v/9ghQ4YODjdeaeAOdIh0uAyRKg3UcufmUKiFg57bDTqUBqrY3RuUCr1B6HAnnaQ3HJhrBTN0OCFSBweHjBluSMHhDS284RGMNu/F5Pn6fRXZ1NDCsuL00cXQvyqm18Qeaoo3xCV0K6ZTw1+o4QH6ilPHOob4OJhOCzU8wIbi7WMdrch0liX63g99ieVIyUVKLpjNEzSkejhrsiW0cAoDHGBgRsFsKsZVvC7gNq4gSMW4h6uI5RTMpuHtAn5FGzEeoo86PsMmTuFLxHII5usy2jjBBfSkGvgNbVzGrhwi87UpcR0943q4LnFFTpH5WpHYN9m+xIqcIiUXma+nEhsm25B4KqfIfN2RuIWGcQ3ckrgnp2C+7mMDn+MPHOAZPsF5BDzEfTkF8xXjInbwNdpoS8S4iy3Exj1BQ6qHsyYI5i/GJm6ghSW8xCEGJqsYV/EGweIMsGs6DVOKlFyk5CLTeS5R935YlXgeTOcQQ6xjD88UZwVfYIjDiuk1sYea4g1xCd2KbGpooq44fXQx9H9RxTVUldAH2MZN/I3flUyEIBGUUJBaQ0c2I7zEAUYKEKSaaMrnFXbwHV5ZoCDVxZFsamjgNLbRxDmcWJAgdYSOfJr4GWfwCy5YkMi70cU5jHAeFy1I5N15gZsSX1mQILsqthC8bkliDR1vNsCfODajILtN/ODtqvjefzvGVTyWU5DdHQQE+QTU8SlW8QjfYFcOQXYnuGF2H+JHfIuf8AKPZRQpzghbuIuA23KIFG8bQ6xiVUZBag0dxRihhjM4lkGQaqKpWB/JKEh1caQ4MXZkFKSO0FEyEWKJWElVcQ1VJfQP6iSCqhi0t9QAAAAASUVORK5CYII="/>
                    </defs>
                </svg>
                <span>Depósitos</span>
            </div>
        </div>

        <!-- ── Tab content ──────────────────────────────────────── -->
        <div class="ev-tab-body">

            <!-- COMBUSTIBLE -->
            <ng-container *ngIf="activeTab === 'combustible'">
                <div class="ev-table-wrap">
                    <table class="ev-table">
                        <thead>
                            <tr>
                                <th>Km</th>
                                <th>Km recorridos</th>
                                <th>Litros</th>
                                <th>Costo</th>
                                <th>¿Quién realizó la carga?</th>
                                <th>Rendimiento</th>
                                <th>Descarga recibo</th>
                                <th *ngIf="!isValidated">Subir recibo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of combustibleRows; let i = index; let odd = odd" [class.ev-row-alt]="odd">
                                <td>{{ r.km | number }}</td>
                                <td>{{ r.kmRec !== null ? (r.kmRec | number) : '-' }}</td>
                                <td>{{ r.litros | number }}</td>
                                <td>{{ r.costo !== null ? formatCurrency(r.costo) : '-' }}</td>
                                <td>{{ r.quien }}</td>
                                <td>{{ r.rendimiento !== null ? (r.rendimiento | number) : '-' }}</td>
                                <td class="ev-icon-cell">
                                    <a *ngIf="r.evidence" [href]="r.evidence" target="_blank">
                                        <i class="ti ti-download ev-icon-dl"></i>
                                    </a>
                                </td>
                                <td class="ev-icon-cell" *ngIf="!isValidated">
                                    <ng-container *ngIf="!r.evidence">
                                        <input type="file" [id]="'ev-comb-file-' + i" accept=".jpg,.jpeg,.png,.pdf"
                                            style="display:none;" (change)="onUploadEvidenceCombustible($event, r)">
                                        <i class="ti ti-upload ev-icon-ul" (click)="triggerEvidenceInput('ev-comb-file-' + i)"></i>
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="ev-total-row">
                                <td><strong>Total:</strong></td>
                                <td><strong>{{ totalKmRecorridos | number:'1.0-3' }}</strong></td>
                                <td><strong>{{ totalLitros | number:'1.0-3' }}</strong></td>
                                <td><strong>{{ formatCurrency(combustibleTotal) }}</strong></td>
                                <td></td>
                                <td><strong>{{ totalRendimiento !== null ? (totalRendimiento | number:'1.0-3') + ' km/L' : '-' }}</strong></td>
                                <td></td>
                                <td *ngIf="!isValidated"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <div class="ev-km-summary">
                    <div class="ev-km-summary__item">
                        <span class="ev-km-summary__label">KM GPS</span>
                        <ng-container *ngIf="!isValidated; else kmGpsReadonly">
                            <input class="ev-km-summary__input" type="number" step="0.01" min="0"
                                [(ngModel)]="kmGps" (blur)="onKmComparisonBlur()">
                        </ng-container>
                        <ng-template #kmGpsReadonly>
                            <span class="ev-km-summary__value">{{ kmGps !== null ? (kmGps | number) : '-' }}</span>
                        </ng-template>
                    </div>
                    <div class="ev-km-summary__item">
                        <span class="ev-km-summary__label">KM Google Maps</span>
                        <span class="ev-km-summary__value">{{ kmGoogleMaps !== null ? (kmGoogleMaps | number) : '-' }}</span>
                    </div>
                    <div class="ev-km-summary__item">
                        <span class="ev-km-summary__label">KM Diferencia</span>
                        <span class="ev-km-summary__value">{{ kmDiferencia !== null ? (kmDiferencia | number) : '-' }}</span>
                        <i *ngIf="savingKmComparison" class="ti ti-loader-2 ev-km-summary__saving"></i>
                    </div>
                </div>
            </ng-container>

            <!-- CASETAS -->
            <ng-container *ngIf="activeTab === 'casetas'">

              <input type="file" id="ev-tag-csv-partida" accept=".csv,.txt" style="display:none;" (change)="onTagCsvUpload($event, 'partida')">
              <input type="file" id="ev-tag-csv-retorno" accept=".csv,.txt" style="display:none;" (change)="onTagCsvUpload($event, 'retorno')">

              <!-- Casetas TAG - Partida -->
              <div class="ev-tab-section-header">
                <span class="ev-tab-section-title">Casetas TAG - Partida</span>
                <button *ngIf="!isValidated" class="ev-btn-upload" (click)="triggerTagCsvInput('partida')" [disabled]="tagTollPartidaUploading">
                  <span *ngIf="!tagTollPartidaUploading"><i class="ti ti-upload"></i> Subir archivo</span>
                  <span *ngIf="tagTollPartidaUploading"><i class="ti ti-loader"></i> Procesando...</span>
                </button>
              </div>
              <div class="ev-table-wrap">
                <table class="ev-table">
                  <thead>
                    <tr><th>TAG</th><th>Tramo</th><th>Partida</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of casetasTagPartidaRows; let odd = odd" [class.ev-row-alt]="odd">
                      <td><div class="ev-select-cell"><span>{{ r.tag_number }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td><div class="ev-select-cell"><span>{{ r.tramo }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td>{{ formatCurrency(r.amount) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="ev-subtotal-row">
                      <td colspan="2" class="ev-td-right">Subtotal:</td>
                      <td>{{ formatCurrency(casetasTagPartidaTotal) }}</td>
                    </tr>
                    <tr class="ev-total-row">
                      <td colspan="2" class="ev-td-right">Total:</td>
                      <td><strong>{{ formatCurrency(casetasTagTotal) }}</strong></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <!-- Casetas TAG - Retorno -->
              <div class="ev-tab-section-header ev-mt-section">
                <span class="ev-tab-section-title">Casetas TAG - Retorno</span>
                <button *ngIf="!isValidated" class="ev-btn-upload" (click)="triggerTagCsvInput('retorno')" [disabled]="tagTollRetornoUploading">
                  <span *ngIf="!tagTollRetornoUploading"><i class="ti ti-upload"></i> Subir archivo</span>
                  <span *ngIf="tagTollRetornoUploading"><i class="ti ti-loader"></i> Procesando...</span>
                </button>
              </div>
              <div class="ev-table-wrap">
                <table class="ev-table">
                  <thead>
                    <tr><th>TAG</th><th>Tramo</th><th>Retorno</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of casetasTagRetornoRows; let odd = odd" [class.ev-row-alt]="odd">
                      <td><div class="ev-select-cell"><span>{{ r.tag_number }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td><div class="ev-select-cell"><span>{{ r.tramo }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td>{{ formatCurrency(r.amount) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="ev-subtotal-row">
                      <td colspan="2" class="ev-td-right">Subtotal:</td>
                      <td>{{ formatCurrency(casetasTagRetornoTotal) }}</td>
                    </tr>
                    <tr class="ev-total-row">
                      <td colspan="2" class="ev-td-right">Total:</td>
                      <td><strong>{{ formatCurrency(casetasTagTotal) }}</strong></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <!-- Casetas en efectivo - Partida -->
              <div class="ev-tab-section-header ev-mt-section">
                <span class="ev-tab-section-title">Casetas en efectivo - Partida</span>
              </div>
              <div class="ev-table-wrap">
                <table class="ev-table">
                  <thead>
                    <tr><th>Caseta</th><th>Tramo</th><th>Partida</th><th>Descarga recibo</th><th *ngIf="!isValidated">Subir recibo</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of casetasEfectivoPartidaRows; let i = index; let odd = odd" [class.ev-row-alt]="odd">
                      <td><div class="ev-select-cell"><span>{{ r.caseta }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td><div class="ev-select-cell"><span>{{ r.tramo }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td>{{ r.amount !== null ? formatCurrency(r.amount) : '-' }}</td>
                      <td class="ev-icon-cell">
                        <a *ngIf="r.evidence" [href]="r.evidence" target="_blank"><i class="ti ti-download ev-icon-dl"></i></a>
                        <span *ngIf="!r.evidence">-</span>
                      </td>
                      <td class="ev-icon-cell" *ngIf="!isValidated">
                        <ng-container *ngIf="!r.evidence">
                          <input type="file" [id]="'ev-cash-partida-' + i" accept=".jpg,.jpeg,.png,.pdf" style="display:none;" (change)="onUploadEvidenceCashToll($event, r)">
                          <i class="ti ti-upload ev-icon-ul" (click)="triggerEvidenceInput('ev-cash-partida-' + i)"></i>
                        </ng-container>
                        <span *ngIf="r.evidence">-</span>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="ev-subtotal-row">
                      <td colspan="2" class="ev-td-right">Subtotal:</td>
                      <td>{{ formatCurrency(casetasEfectivoPartidaTotal) }}</td>
                      <td [attr.colspan]="isValidated ? 1 : 2"></td>
                    </tr>
                    <tr class="ev-total-row">
                      <td colspan="2" class="ev-td-right">Total:</td>
                      <td><strong>{{ formatCurrency(casetasEfectivoTotal) }}</strong></td>
                      <td [attr.colspan]="isValidated ? 1 : 2"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <!-- Casetas en efectivo - Retorno -->
              <div class="ev-tab-section-header ev-mt-section">
                <span class="ev-tab-section-title">Casetas en efectivo - Retorno</span>
              </div>
              <div class="ev-table-wrap">
                <table class="ev-table">
                  <thead>
                    <tr><th>Caseta</th><th>Tramo</th><th>Retorno</th><th>Descarga recibo</th><th *ngIf="!isValidated">Subir recibo</th></tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let r of casetasEfectivoRetornoRows; let i = index; let odd = odd" [class.ev-row-alt]="odd">
                      <td><div class="ev-select-cell"><span>{{ r.caseta }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td><div class="ev-select-cell"><span>{{ r.tramo }}</span><i class="ti ti-chevron-down ev-select-arrow"></i></div></td>
                      <td>{{ r.amount !== null ? formatCurrency(r.amount) : '-' }}</td>
                      <td class="ev-icon-cell">
                        <a *ngIf="r.evidence" [href]="r.evidence" target="_blank"><i class="ti ti-download ev-icon-dl"></i></a>
                        <span *ngIf="!r.evidence">-</span>
                      </td>
                      <td class="ev-icon-cell" *ngIf="!isValidated">
                        <ng-container *ngIf="!r.evidence">
                          <input type="file" [id]="'ev-cash-retorno-' + i" accept=".jpg,.jpeg,.png,.pdf" style="display:none;" (change)="onUploadEvidenceCashToll($event, r)">
                          <i class="ti ti-upload ev-icon-ul" (click)="triggerEvidenceInput('ev-cash-retorno-' + i)"></i>
                        </ng-container>
                        <span *ngIf="r.evidence">-</span>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="ev-subtotal-row">
                      <td colspan="2" class="ev-td-right">Subtotal:</td>
                      <td>{{ formatCurrency(casetasEfectivoRetornoTotal) }}</td>
                      <td [attr.colspan]="isValidated ? 1 : 2"></td>
                    </tr>
                    <tr class="ev-total-row">
                      <td colspan="2" class="ev-td-right">Total:</td>
                      <td><strong>{{ formatCurrency(casetasEfectivoTotal) }}</strong></td>
                      <td [attr.colspan]="isValidated ? 1 : 2"></td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <!-- Summary bar -->
              <div class="ev-casetas-bar">
                <div class="ev-casetas-bar__item">
                  <span>Total casetas tag:</span>
                  <strong>{{ formatCurrency(casetasTagTotal) }}</strong>
                </div>
                <div class="ev-casetas-bar__item">
                  <span>Total casetas efectivo:</span>
                  <strong>{{ formatCurrency(casetasEfectivoTotal) }}</strong>
                </div>
                <div class="ev-casetas-bar__item ev-casetas-bar__item--last">
                  <span>Total de casetas:</span>
                  <strong>{{ formatCurrency(casetasTagTotal + casetasEfectivoTotal) }}</strong>
                </div>
              </div>

            </ng-container>

            <!-- ALIMENTOS -->
            <ng-container *ngIf="activeTab === 'alimentos'">
                <div class="ev-table-wrap">
                    <table class="ev-table">
                        <thead>
                            <tr>
                                <th class="ev-th-check" *ngIf="!isValidated">
                                    <input type="checkbox" [checked]="allAlimentosChecked"
                                        (change)="toggleAllAlimentos($any($event.target).checked); onCheckChange()">
                                </th>
                                <th>Descripción</th>
                                <th>Pago en efectivo</th>
                                <th>Descargar recibo</th>
                                <th *ngIf="!isValidated">Subir recibo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of alimentosRows; let i = index; let odd = odd" [class.ev-row-alt]="odd"
                                [class.ev-row-checked]="r.checked">
                                <td class="ev-td-check" *ngIf="!isValidated">
                                    <input type="checkbox" [(ngModel)]="r.checked" (ngModelChange)="onCheckChange()">
                                </td>
                                <td [class.ev-text-red]="r.checked">{{ r.desc }}</td>
                                <td [class.ev-text-red]="r.checked">
                                    {{ r.monto !== null ? (r.checked ? '-' : '') + formatCurrency(r.monto) : '-' }}
                                </td>
                                <td class="ev-icon-cell">
                                    <a *ngIf="r.evidence" [href]="r.evidence" target="_blank">
                                        <i class="ti ti-download ev-icon-dl"></i>
                                    </a>
                                </td>
                                <td class="ev-icon-cell" *ngIf="!isValidated">
                                    <ng-container *ngIf="!r.evidence">
                                        <input type="file" [id]="'ev-alim-file-' + i" accept=".jpg,.jpeg,.png,.pdf"
                                            style="display:none;" (change)="onUploadEvidence($event, r)">
                                        <i class="ti ti-upload ev-icon-ul" (click)="triggerEvidenceInput('ev-alim-file-' + i)"></i>
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="ev-total-row">
                                <td [attr.colspan]="isValidated ? 1 : 2" class="text-end"><strong>Total:</strong></td>
                                <td><strong>{{ formatCurrency(alimentosTotal) }}</strong></td>
                                <td></td>
                                <td *ngIf="!isValidated"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </ng-container>

            <!-- OTROS GASTOS -->
            <ng-container *ngIf="activeTab === 'otros'">
                <div class="ev-table-wrap">
                    <table class="ev-table">
                        <thead>
                            <tr>
                                <th class="ev-th-check" *ngIf="!isValidated">
                                    <input type="checkbox" [checked]="allOtrosChecked"
                                        (change)="toggleAllOtros($any($event.target).checked); onCheckChange()">
                                </th>
                                <th>Descripción</th>
                                <th>Pago en efectivo</th>
                                <th>Descarga recibo</th>
                                <th *ngIf="!isValidated">Subir recibo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of otrosRows; let i = index; let odd = odd" [class.ev-row-alt]="odd"
                                [class.ev-row-checked]="r.checked">
                                <td class="ev-td-check" *ngIf="!isValidated">
                                    <input type="checkbox" [(ngModel)]="r.checked" (ngModelChange)="onCheckChange()">
                                </td>
                                <td [class.ev-text-red]="r.checked">{{ r.desc }}</td>
                                <td [class.ev-text-red]="r.checked">
                                    {{ r.monto !== null ? (r.checked ? '-' : '') + formatCurrency(r.monto) : '-' }}
                                </td>
                                <td class="ev-icon-cell">
                                    <a *ngIf="r.evidence" [href]="r.evidence" target="_blank">
                                        <i class="ti ti-download ev-icon-dl"></i>
                                    </a>
                                </td>
                                <td class="ev-icon-cell" *ngIf="!isValidated">
                                    <ng-container *ngIf="!r.evidence">
                                        <input type="file" [id]="'ev-otros-file-' + i" accept=".jpg,.jpeg,.png,.pdf"
                                            style="display:none;" (change)="onUploadEvidence($event, r)">
                                        <i class="ti ti-upload ev-icon-ul" (click)="triggerEvidenceInput('ev-otros-file-' + i)"></i>
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="ev-total-row">
                                <td [attr.colspan]="isValidated ? 1 : 2" class="text-end"><strong>Total:</strong></td>
                                <td><strong>{{ formatCurrency(otrosTotal) }}</strong></td>
                                <td></td>
                                <td *ngIf="!isValidated"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </ng-container>

            <!-- DEPÓSITOS -->
            <ng-container *ngIf="activeTab === 'depositos'">
                <div class="ev-table-wrap">
                    <table class="ev-table">
                        <thead>
                            <tr>
                                <th>Depósitos realizados</th>
                                <th>Monto</th>
                                <th>Descarga recibo</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of depositosRows; let odd = odd" [class.ev-row-alt]="odd">
                                <td>{{ r.label }}</td>
                                <td>{{ r.monto !== null ? formatCurrency(r.monto) : '-' }}</td>
                                <td class="ev-icon-cell">
                                    <a *ngIf="r.evidence" [href]="r.evidence" target="_blank">
                                        <i class="ti ti-download ev-icon-dl"></i>
                                    </a>
                                    <span *ngIf="!r.evidence">-</span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr class="ev-total-row">
                                <td class="text-end"><strong>Total:</strong></td>
                                <td><strong>{{ formatCurrency(depositosTotal) }}</strong></td>
                                <td></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </ng-container>

        </div>
    </div>

    <!-- ── Modal de validación ───────────────────────────────────── -->
    <div class="ev-vm-backdrop" *ngIf="showValidationModal" (click)="closeValidationModal()">
        <div class="ev-vm" (click)="$event.stopPropagation()">
            <div class="ev-vm__header">
                <h5 class="ev-vm__title">Validación de gastos del servicio</h5>
                <button class="ev-vm__close" (click)="closeValidationModal()">&#x2715;</button>
            </div>
            <div class="ev-vm__body">
                <p class="ev-vm__question">¿Toda la información registrada se encuentra correctamente validada? Una vez confirmada la información, ya no se podrá editar nuevamente</p>
                <div class="ev-vm__options">
                    <label class="ev-vm__option">
                        <input type="checkbox" [checked]="validationIsValid" (change)="validationIsValid = true">
                        <span>Si</span>
                    </label>
                    <label class="ev-vm__option">
                        <input type="checkbox" [checked]="!validationIsValid" (change)="validationIsValid = false">
                        <span>No</span>
                    </label>
                </div>
                <ng-container *ngIf="!validationIsValid">
                    <p class="ev-vm__sublabel">¿Que inconsistencia presenta la validación de gastos? Por favor ingrese la descripción</p>
                    <div class="ev-vm__textarea-wrap">
                        <textarea class="ev-vm__textarea" [(ngModel)]="inconsistencyDesc" maxlength="500" rows="4"></textarea>
                        <span class="ev-vm__char-count">{{ inconsistencyDesc.length }}/500</span>
                    </div>
                </ng-container>
                <p class="ev-vm__sublabel">¿Quien realiza la validación?</p>
                <input class="ev-vm__input" type="text" [value]="validatorName" readonly>
            </div>
            <div class="ev-vm__footer">
                <button class="ev-vm__btn ev-vm__btn--cancel" (click)="closeValidationModal()">Cancelar</button>
                <button class="ev-vm__btn ev-vm__btn--confirm"
                    [disabled]="!validatorName.trim() || submittingValidation"
                    (click)="submitValidation()">
                    {{ submittingValidation ? 'Guardando...' : 'Validar' }}
                </button>
            </div>
        </div>
    </div>

    <!-- ── Resumen de cálculo (fixed bottom) ───────────────────── -->
    <div class="ev-resumen" #resumenPanel>
        <div class="ev-resumen__body">

            <div class="ev-resumen__left">
                <div class="ev-resumen__header" (click)="resumenExpanded = !resumenExpanded">
                    <span class="ev-resumen__title">Resumen de cálculo</span>
                    <i class="ti" [ngClass]="resumenExpanded ? 'ti-chevron-up' : 'ti-chevron-down'"></i>
                </div>

                <ng-container *ngIf="resumenExpanded">
                    <p class="ev-resumen__hint">
                        <span>Selecciona las categorías de gastos que deseas incluir para calcular el saldo.</span>
                        <span class="ev-resumen__info-wrap">
                            <i class="ti ti-info-circle" (click)="toggleResumenInfo($event)"></i>
                            <div class="ev-resumen__info-popover" *ngIf="resumenInfoOpen"
                                [style.bottom.px]="resumenInfoBottom" [style.left.px]="resumenInfoLeft">
                                Solo las categorías activadas se consideran para calcular el saldo remanente o adeudado.
                            </div>
                        </span>
                    </p>

                    <div class="ev-resumen-cat">
                        <div class="ev-resumen-cat__headers">
                            <span class="ev-resumen-cat__headers-toggle">Incluir en cálculo</span>
                            <span class="ev-resumen-cat__headers-amount">Total de la categoría</span>
                        </div>
                        <div class="ev-resumen-cat__row" *ngFor="let c of categoriasResumen">
                            <div class="ev-resumen-cat__label"><i class="ti" [ngClass]="c.icon"></i> {{ c.label }}</div>
                            <label class="ev-switch">
                                <input type="checkbox" [(ngModel)]="c.included" (change)="onCategoriaToggle()">
                                <span class="ev-switch__slider"></span>
                            </label>
                            <span class="ev-resumen-cat__amount">{{ formatCurrency(c.total) }}</span>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="!resumenExpanded">
                    <div class="ev-resumen__count">
                        <i class="ti ti-circle-check"></i>
                        {{ categoriasSeleccionadasCount }} de {{ categoriasResumen.length }} categorías seleccionadas
                        <i *ngIf="savingCategoriasIncluidas" class="ti ti-loader-2 ev-km-summary__saving"></i>
                    </div>

                    <div class="ev-resumen__notice">
                        <i class="ti ti-info-circle"></i>
                        Solo las categorías activadas se consideran para calcular el saldo remanente o adeudado.
                    </div>
                </ng-container>
            </div>

            <div class="ev-resumen__right">
                <div class="ev-resumen__summary-box ev-resumen__summary-box--deposito">
                    <i class="ti ti-wallet"></i>
                    <div class="ev-resumen__summary-text">
                        <span class="ev-resumen__summary-label">Total depósitos</span>
                        <span class="ev-resumen__summary-sub">Suma de todos los depósitos registrados</span>
                    </div>
                    <span class="ev-resumen__summary-amount">{{ formatCurrency(depositosTotal) }}</span>
                </div>
                <div class="ev-resumen__summary-box ev-resumen__summary-box--gasto">
                    <i class="ti ti-receipt"></i>
                    <div class="ev-resumen__summary-text">
                        <span class="ev-resumen__summary-label">Total gastos</span>
                        <span class="ev-resumen__summary-sub">Suma de las categorías incluidas en el cálculo</span>
                    </div>
                    <span class="ev-resumen__summary-amount">{{ formatCurrency(totalGastosCalculado) }}</span>
                </div>

                <span class="ev-resumen__methodology-wrap">
                    <button type="button" class="ev-resumen__methodology-trigger" (click)="toggleResumenMethodology($event)"
                        aria-label="¿Cómo se calcula el saldo remanente y adeudado?" title="¿Cómo se calcula el saldo remanente y adeudado?">
                        <i class="ti ti-info-circle"></i>
                    </button>
                    <div class="ev-methodology" *ngIf="resumenMethodologyOpen"
                        [style.bottom.px]="resumenMethodologyBottom" [style.left.px]="resumenMethodologyLeft">
                        <div class="ev-methodology__head">
                            <p class="ev-methodology__title">¿Cómo se calcula el saldo remanente y adeudado?</p>
                            <p class="ev-methodology__subtitle">El sistema determina automáticamente el resultado según el balance.</p>
                        </div>
                        <div class="ev-methodology__columns">
                            <div class="ev-methodology__card ev-methodology__card--positive">
                                <div>
                                    <p class="ev-methodology__card-title">Balance &gt; 0</p>
                                    <p class="ev-methodology__card-sub">Depósitos &gt; Gastos seleccionados</p>
                                </div>
                                <div class="ev-methodology__row">
                                    <span class="ev-methodology__circle ev-methodology__circle--positive"><i class="ti ti-plus"></i></span>
                                    <span class="ev-methodology__divider"></span>
                                    <div class="ev-methodology__text">
                                        <span class="ev-methodology__text-title">Saldo remanente</span>
                                        <span class="ev-methodology__text-sub">El operador debe devolver este monto.</span>
                                    </div>
                                </div>
                                <span class="ev-methodology__badge ev-methodology__badge--positive">Ejemplo: +$450,00</span>
                            </div>
                            <div class="ev-methodology__card ev-methodology__card--negative">
                                <div>
                                    <p class="ev-methodology__card-title">Balance &lt; 0</p>
                                    <p class="ev-methodology__card-sub">Gastos seleccionados &gt; Depósitos</p>
                                </div>
                                <div class="ev-methodology__row">
                                    <span class="ev-methodology__circle ev-methodology__circle--negative"><i class="ti ti-minus"></i></span>
                                    <span class="ev-methodology__divider"></span>
                                    <div class="ev-methodology__text">
                                        <span class="ev-methodology__text-title">Saldo adeudado</span>
                                        <span class="ev-methodology__text-sub">El operador debe cubrir este monto.</span>
                                    </div>
                                </div>
                                <span class="ev-methodology__badge ev-methodology__badge--negative">Ejemplo: -$200,00</span>
                            </div>
                            <div class="ev-methodology__card ev-methodology__card--neutral">
                                <div>
                                    <p class="ev-methodology__card-title">Balance = 0</p>
                                    <p class="ev-methodology__card-sub">Depósitos = Gastos seleccionados</p>
                                </div>
                                <div class="ev-methodology__row">
                                    <span class="ev-methodology__circle ev-methodology__circle--neutral"><i class="ti ti-info-circle"></i></span>
                                    <span class="ev-methodology__divider"></span>
                                    <div class="ev-methodology__text">
                                        <span class="ev-methodology__text-title">Saldo en equilibrio</span>
                                        <span class="ev-methodology__text-sub">No existe saldo pendiente.</span>
                                    </div>
                                </div>
                                <span class="ev-methodology__badge ev-methodology__badge--neutral">Ejemplo: $0,00</span>
                            </div>
                        </div>
                    </div>
                </span>

                <div class="ev-resumen__divider"></div>
                <div class="ev-resumen__summary-box ev-resumen__summary-box--saldo"
                    [class.ev-resumen__summary-box--negative]="saldoCalculado < 0"
                    [class.ev-resumen__summary-box--positive]="saldoCalculado > 0"
                    [class.ev-resumen__summary-box--neutral]="saldoCalculado === 0">
                    <i class="ti" [ngClass]="saldoIcon"></i>
                    <div class="ev-resumen__summary-text">
                        <span class="ev-resumen__summary-label">{{ saldoLabel }}</span>
                        <span class="ev-resumen__summary-sub">{{ saldoSub }}</span>
                    </div>
                    <span class="ev-resumen__summary-amount">{{ formatCurrency(saldoCalculado) }}</span>
                </div>
            </div>

        </div>
    </div>

</div>